import NietErnstigeBloedingenOnderDoac from "../../../../src/client/lta-antistolling/niet-ernstige-bloedingen-onder-doac.json";
import ChartCollapse from "../../../../src/components/interactions/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  NietErnstigeBloedingenOnderDoac,
  ChartCollapse,
  React
};